import { Flex, Box, Image, Stack, Heading, Text } from "@chakra-ui/react";
import React from "react";
import CommonContainer from "../shared/CommonContainer";

export default function BenefitsSection() {
  return (
    <Flex bg={"brand.50"} py={{ base: 10, md: 20 }}>
      <CommonContainer>
        <Flex
          flexDirection={{ base: "column", xl: "row" }}
          gap={5}
          justifyContent="space-between"
        >
          <Stack width={{ xl: "40%" }} gap={2}>
            <Box>
              <Heading
                fontWeight={"semibold"}
                fontSize={{ base: "24px", "2xl": "40px" }}
                pb={4}
              >
                Decolance Affiliate Benefits
              </Heading>
            </Box>
            {data.map((item,index) => {
              return (
                <Box key={index}>
                  <Heading
                    as="h6"
                    fontWeight={"semibold"}
                    fontSize={{ base: "16px",md:"18px", "2xl": "22" }}
                  >
                    {item.title}
                  </Heading>
                  <Text
                    fontSize={{ base: "14px",md:"18px", "2xl": "21" }}
                    color="grey"
                    py={4}
                    lineHeight="25px"
                  >
                    {item.description}
                  </Text>
                </Box>
              );
            })}
          </Stack>
          <Stack
            width={{ xl: "55%" }}
            alignItems="center"
            justifyContent="center"
          >
            <Image
              src="/images/affiliate/benefits.png"
              w="full"
              maxW={{ xl: "80%", "2xl": "full" }}
            />
          </Stack>
        </Flex>
      </CommonContainer>
    </Flex>
  );
}
const data = [
  {
    title: "Maximum Earnings",
    description:
      "Get paid for every first-time buyer, with no referral limit and a lifetime attribution",
  },
  {
    title: "Professional Support",
    description:
      "Gain access to professional support, tutorials, and a dedicated Affiliate manager  ",
  },
  {
    title: "Intuitive Dashboards",
    description:
      "Easy-to-use dashboards to launch, manage and monitor campaigns",
  },
  {
    title: "Creative Resources",
    description:
      "A portfolio of high-performing creative assets to help you promote",
  },
];
